import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import { SvgIconComponent } from '@mui/icons-material';
import { ConnectAlternativeIcon } from './connect-alternative';

/** Maps alternative icon keys to MUI outlined icons. */
export const connectAlternativeIcons: Record<ConnectAlternativeIcon, SvgIconComponent> = {
  login: LoginOutlinedIcon,
  key: VpnKeyOutlinedIcon,
  business: BusinessOutlinedIcon,
  basic: UploadOutlinedIcon,
  advanced: TuneOutlinedIcon,
};
